import { useNavigate } from 'react-router-dom'

export default function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center text-center px-6"
      style={{ background: 'var(--color-void)', color: 'var(--color-text)' }}
    >
      <p className="font-mono text-xs tracking-widest mb-4" style={{ color: 'var(--color-gold)' }}>
        404
      </p>
      <h1 className="text-3xl mb-4" style={{ fontFamily: 'var(--font-display)' }}>
        Page not found.
      </h1>
      <button
        onClick={() => navigate('/')}
        className="text-sm font-sans"
        style={{ color: 'var(--color-text-muted)' }}
      >
        ← Back to home
      </button>
    </div>
  )
}
